export default "__VITE_ASSET__BlmQhE7E__"